module.exports = "/_next/static/images/CustomerStoryEndeavor-d8ff09fbc372b537fbdeff64200513db.png";